module.exports = __webpack_public_path__ + "static/media/mh.13eeebed.svg";